export default __webpack_public_path__ + "static/media/Helvetica-Bold-Font.c376facf.ttf";